import React from 'react';
import PropTypes from 'prop-types';

import Page from 'components/Page';

import './style.css';

/* eslint-disable max-len */
const InterestInvite = ({login, invite}) => (
  <section className="pageContainer">
    <Page>
      <section styleName="inviteContainer">
        <img src={invite.syndicator.image} alt={invite.syndicator.name} />
        <h3>{invite.syndicator.name} invited you to invest in {invite.deal.name}</h3>
      </section>
      <p styleName="login">
        To see this deal, you need to <a onClick={login} role="button" tabIndex="0" data-test="login">login</a>
      </p>
    </Page>
  </section>
);
/* eslint-enable max-len */

InterestInvite.propTypes = {
  login: PropTypes.func.isRequired,
  invite: PropTypes.object,
};

export default InterestInvite;



// WEBPACK FOOTER //
// ./web/flows/interest/invite/component.js